import { useCallback, useState } from 'react';

import GetConversationService from '../services/apiConversation';

/**
 * @description Hook para pegar contagens no monitoramento de chat
 * @returns {{
 *  monitoringData: any;
 * getMonitoringData: (params?: any) => Promise<any>;
 * isLoadingMonitoringData: boolean;
 * setIsLoadingMonitoringData: React.Dispatch<React.SetStateAction<boolean>>;
 * setMonitoringData: React.Dispatch<React.SetStateAction<any>>;
 * }}
 */
export const useChatMonitoring = () => {
  const [monitoringData, setMonitoringData] = useState(null);
  const [isLoadingMonitoringData, setIsLoadingMonitoringData] = useState(false);
  const getMonitoringData = useCallback(
    async (params = {}) => {
      setIsLoadingMonitoringData(true);
      try {
        const response = await GetConversationService.getMonitoringData({
          queryParams: params
        });

        return response.data;
      } catch (error) {
        console.error(error);
      } finally {
        setIsLoadingMonitoringData(false);
      }
    },
    [monitoringData]
  );

  return {
    monitoringData,
    getMonitoringData,
    isLoadingMonitoringData,
    setIsLoadingMonitoringData,
    setMonitoringData
  };
};
